module.exports = __webpack_public_path__ + "static/don7-06b11c32d2a3837da58e075cd776fe56.jpg";